import { jwtDecode } from "jwt-decode";
import { useLoginStore, useAdminStore } from "@/store";

let isAdminLoaded = false;

export const routerGuard = async (to) => {
  const userType = "admin";

  const loginStore = useLoginStore();
  const adminStore = useAdminStore();

  loginStore.setTokens();

  let accessToken = loginStore.getAccessToken;
  let refreshToken = loginStore.getRefreshToken;

  // Allow login page
  if (to.path === "/login") {
    return true;
  }

  // No tokens → login
  if (!accessToken && !refreshToken) {
    return "/login";
  }

  try {
    // Validate access token
    if (accessToken && !isAdminLoaded) {
      const response = await loginStore.validateAccessToken(userType);

      if (!response.success) {
        accessToken = null;
      }
    }

    // Refresh access token
    if (!accessToken && refreshToken) {
      const response = await loginStore.validateRefreshToken(userType);

      if (!response.status) {
        loginStore.removeTokens();
        return "/login";
      }

      accessToken = response.accessToken;
      refreshToken = response.refreshToken;

      loginStore.setAccessToken(accessToken);
      loginStore.setRefreshToken(refreshToken);
    }

    // Load admin details
    if (accessToken && !isAdminLoaded) {
      const decoded = jwtDecode(accessToken);

      if (!decoded?.userId) {
        loginStore.removeTokens();
        return "/login";
      }

      const response = await adminStore.getAdminDetails(decoded.userId);

      if (response?.status && response.status !== 404) {
        loginStore.setLoginDetails(response.data[0]);
        isAdminLoaded = true;
      }
    }

    return true;
  } catch (error) {
    isAdminLoaded = false;
    loginStore.removeTokens();

    return "/login";
  }
};
